export default class Pagination {
    constructor(context) {
        this.refs = {
            disabledNodes: context.querySelectorAll('[aria-disabled="true"]'),
            pageNodes: context.querySelectorAll('[data-pagination-page]'),
            pageNumberNode: document.querySelector('[name="PageNumber"]')
        };

        this.init();
    }

    init() {
        this.refs.disabledNodes.forEach(disabledNode => {
            disabledNode.addEventListener('click', e => e.preventDefault());
        });

        this.refs.pageNodes.forEach(pageNode => {
            pageNode.addEventListener('click', e => {
                e.preventDefault();

                const node = e.currentTarget;
                const pageNumber = node.getAttribute('data-pagination-page');

                this.setPageNumber(pageNumber);
            });
        });
    }

    setPageNumber(pageNumber) {
        const event = new CustomEvent('change');

        this.refs.pageNumberNode.value = pageNumber;
        this.refs.pageNumberNode.dispatchEvent(event);
    }
}
